import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEars = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 118,
	height: 23,
	viewBox: "0 0 118 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M25.1829 23H43.3258C43.3258 23 40.7968 15.7936 35.0435 8.5C29.2901 1.20637 25.1829 0 25.1829 0C25.1829 0 24 4 24 12.5C24 16.9053 25.1829 23 25.1829 23Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M92.8171 23H74.6742C74.6742 23 77.2032 15.7936 82.9565 8.5C88.7099 1.20637 92.8171 0 92.8171 0C92.8171 0 94 4 94 12.5C94 16.9053 92.8171 23 92.8171 23Z",
		fill: "white"
	})]
});
export default SvgEars;
